/**
 * @generated SignedSource<<187696caef463d1310cdc63e214a076b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBuildConfigPanel_appConfig$data = {
  readonly androidAppIdentifier: string;
  readonly appName: string;
  readonly appTrackingDialogEnabled: boolean;
  readonly iosAppIdentifier: string;
  readonly iosAscIssuerId: string;
  readonly iosAscKeyId: string;
  readonly iosAscTeamId: string;
  readonly " $fragmentType": "InternBuildConfigPanel_appConfig";
};
export type InternBuildConfigPanel_appConfig$key = {
  readonly " $data"?: InternBuildConfigPanel_appConfig$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBuildConfigPanel_appConfig">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBuildConfigPanel_appConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosAppIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosAscTeamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosAscKeyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosAscIssuerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appTrackingDialogEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "androidAppIdentifier",
      "storageKey": null
    }
  ],
  "type": "BrandAppConfigType",
  "abstractKey": null
};

(node as any).hash = "4aa38f0f9e0af08563653a932006d94f";

export default node;
